<template>
  <div>
    <courseEvaluateCommon :current="currentCourse"></courseEvaluateCommon>
  </div>
</template>

<script>
import courseEvaluateCommon from "./components/course-evaluate-common.vue";
export default {
  components: {
    courseEvaluateCommon,
  },
  data() {
    return {
      currentCourse: "A",
    };
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/service/course-evaluation-A/index.vue